import { memo, useMemo } from 'react';
import { HashRouter, MemoryRouter, Navigate, Route, Routes } from 'react-router';

import Main from './components/Main';
import { LivescoreFeedProvider, LivescoreOptionsProvider } from './store';
import type { LivescoreOptions } from './store/types';

const Calendar = ({ options }: { options: LivescoreOptions }) => {
  const Router = options.disableRouting ? MemoryRouter : HashRouter;

  const ops = useMemo(
    () => ({
      ...options,
      competitionIds: options.competitions.map((c) => c.id),
    }),
    [options],
  );

  return (
    <LivescoreOptionsProvider options={ops}>
      <LivescoreFeedProvider>
        <Router>
          <Routes>
            <Route index element={<Main />} />
            <Route path='/:tabId' element={<Main />} />
            <Route path='*' element={<Navigate to='/' />} />
          </Routes>
        </Router>
      </LivescoreFeedProvider>
    </LivescoreOptionsProvider>
  );
};

export default memo(Calendar);
